import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// ZLF 架構：翻譯由 usePageTranslation / useComponentTranslation 動態載入
// 不再使用集中式的大 JSON 檔案
export const resources = {
    'zh-TW': { translation: {} },
    'en-US': { translation: {} },
} as const;

export const supportedLanguages = [
    { code: 'zh-TW', name: '繁體中文', nativeName: '繁體中文' },
    { code: 'en-US', name: 'English', nativeName: 'English' },
] as const;

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'zh-TW',
        defaultNS: 'translation',
        interpolation: {
            escapeValue: false,
        },
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
            lookupLocalStorage: 'i18nextLng',
        },
    });

export default i18n;
